import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Table, Loader} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import './box-verification.scss';

class VerifyBoxModal extends Component {
  fetchData() {
    const {invoice, box} = this.props;
    this.props.verifyBox(invoice, box);
  }

  renderItems() {
    const {listBoxes} = this.props;

    if (!listBoxes.length) {
      return (
        <Table.Row>
          <Table.Cell textAlign='center' colSpan={6}>No hay datos Disponibles</Table.Cell>
        </Table.Row>
      );
    }

    return listBoxes.map((element, index) => {
      return (
        <Table.Row key={index}>
          <Table.Cell textAlign='center'>{element.partCode}</Table.Cell>
          <Table.Cell textAlign='center'>{element.partName}</Table.Cell>
          <Table.Cell textAlign='center'>{element.expectedQuantity}</Table.Cell>
          <Table.Cell textAlign='center'>{element.receivedQuantity}</Table.Cell>
          <Table.Cell textAlign='center'>{element.pendingQuantity}</Table.Cell>
          <Table.Cell textAlign='center'>{element.location}</Table.Cell>
        </Table.Row>
      );
    });
  }

  renderData() {
    const {loading} = this.props;

    if (loading) {
      return (
        <Table.Row className='loader'>
          <Table.Cell colSpan='100%'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }
    return this.renderItems();
  }
  
  render() {
    const {invoice, box} = this.props;

    return (
      <Modal size={'large'} className='box-verification'
        onOpen={() => this.fetchData()}
        trigger={<div className='link'>
          VERIFICAR
        </div>} closeIcon>

        <Modal.Header>
          {invoice} {'>'} {box}
        </Modal.Header>
        
        <Modal.Content scrolling>
          <Modal.Description>

            <Table striped className='toyota-grid'>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell textAlign='center'>Código</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Descripción</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Factura</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Revisión</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Diferencia</Table.HeaderCell>
                  <Table.HeaderCell textAlign='center'>Ubicación</Table.HeaderCell>
                </Table.Row>
              </Table.Header>
          
              <Table.Body>
                {this.renderData()}
              </Table.Body>
            </Table>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.verifyBox.loading,
    'listBoxes': state.verifyBox.verifiedBoxesList,
  };
};

const {
  verifyBox,
} = Actions;

export default connect(mapStateToProps, {
  verifyBox,
})(VerifyBoxModal);
